import { useEffect, useCallback, useState } from 'react';
import { useQuery } from '@shared/lib/routing';
import { resetCart } from '../api';

function useCityChange(currentCityTextId: string) {
  const [hasCityChanged, setHasCityChanged] = useState(false);

  const checkCityChange = useCallback(() => {
    const cityIdFromStorage = localStorage.getItem('currentCityTextId');
    if (!cityIdFromStorage) {
      localStorage.setItem('currentCityTextId', currentCityTextId);
    } else if (cityIdFromStorage !== currentCityTextId) {
      localStorage.setItem('currentCityTextId', currentCityTextId);
      setHasCityChanged(true);
    }
  }, [currentCityTextId]);

  // one tab
  useEffect(() => {
    checkCityChange();
  }, [checkCityChange]);

  // different tabs
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        checkCityChange();
      }
      if (document.visibilityState === 'hidden') {
        setHasCityChanged(false);
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () =>
      document.removeEventListener('visibilitychange', handleVisibilityChange);
  }, [checkCityChange]);

  return { hasCityChanged };
}

const useResetCartOnChangeCity = (hasCityChanged: boolean) => {
  const params = useQuery();
  const hasProductOrPromocodeParam =
    params.has('product') || params.has('promocode');
  useEffect(() => {
    // из за src/server/middleware/calculate-by-query-params.ts  блокируем сброс корзины
    if (hasProductOrPromocodeParam) return;
    if (hasCityChanged) {
      resetCart();
    }
  }, [hasCityChanged, hasProductOrPromocodeParam]);
};
export function ResetCartOnChangeCity({ cityTextId }: { cityTextId: string }) {
  const { hasCityChanged } = useCityChange(cityTextId);
  useResetCartOnChangeCity(hasCityChanged);

  return null;
}
